export default __webpack_public_path__ + "static/media/tip_guard.66fc50b3.png";